/* eslint-disable react-hooks/exhaustive-deps */
import React, {
	useEffect,
	useMemo,
	useState,
	useRef,
} from "react";
import Loader from "../../../general/Loader";
import { request } from "../../../../utils/request";
import {
	formatCurrency,
	generarUUID,
	getLink,
	getVendedoresForDropdown,
	huellaFormData,
	isPastDate,
	isVendedor,
	money,
	toast,
	validarPINSeguridad,
} from "../../../../utils/helpers";
import { useHistory } from "../../../../utils/router";
import { apiRequest } from "../../../../hooks/apiRequest";

import Create from "../../../Contactos/Create";
import Edit from "../../../Contactos/Edit";
import Modal from "../../../general/Modal";
import ProductosFactura from "./ProductosFactura";
import ProductosFacturaMobile from "./ProductosFacturaMobile";
import Detalles from "./Detalles";
import dayjs from "dayjs";
import { auth } from "../../../../utils/auth";
import useLocalStorage from "../../../../hooks/useLocalStorage";
import { PagoModalFooter } from "..";
import PagoForm from "../../Components/PagoForm";
import FileLoader from "../../../general/FileLoader";

import { calcularDescuento, calcularExentoGrabado, calcularImpuestos, calcularSubtotal, calcularTotal, calcularTotalImpuestos, templateProducto } from "../../Components/utils";
import Select from "react-select";
import { PLAZO_VACIO, plazosParaContacto } from "../../../../utils/plazos";

const canSaveAndPay = (isEdit, saving, fecha, tienePagos = false, fromOrden = false) =>
    fromOrden ||
	(!tienePagos && !saving && isEdit && !isPastDate(fecha)) ||
	(!tienePagos && !isEdit && !saving && !isPastDate(fecha));

// Tras este tiempo se aborta el guardado. Sin esto un socket colgado congela el
// formulario hasta el timeout del navegador (~5 min en Chrome), que es justo lo
// que lleva al usuario a recargar y volver a guardar.
const TIEMPO_LIMITE_GUARDADO = 60000;

// El API puede devolver data.message como mapa campo -> string[] o, en algunos
// casos, con valores que no son arreglos. Se normaliza en el único punto de
// ingreso para que los ~40 sitios que hacen errors.X[0] sigan siendo correctos.
const normalizarErrores = (mapa) =>
	Object.keys(mapa).reduce((acc, clave) => {
		acc[clave] = Array.isArray(mapa[clave])
			? mapa[clave]
			: [String(mapa[clave])];
		return acc;
	}, {});

const Form = ({ facturaActual, isEdit, isRecovery, fromPlantilla, setFacturaGuardada }) => {
	const [fromOrden] = useLocalStorage("fromOrden");
	const history = useHistory();

	const formRef = useRef();
	const [loading, setLoading] = useState(true);

	//Cosas generales como formulario
	const [form, setForm] = useState({
		factura: {},
		fecha: dayjs().format("YYYY-MM-DD"),
		fecha_vencimiento: dayjs().format("YYYY-MM-DD"),
		notas: "",
		categorias: [],
		prevTotal: 0,
		porCobrar: 0,
	});

    const [contactoId, setContactoId] = useState();
    const [facturaProductos, setFacturaProductos] = useState([
        templateProducto(Date.now())
    ]);
    const [comprobante, setComprobante] = useState({});
    const [plazo, setPlazo] = useState(PLAZO_VACIO);
    const [errors, setErrors] = useState({});
    const [errorGeneral, setErrorGeneral] = useState(null);
    const [razonCancelacion, setRazonCancelacion] = useState(null);

	const [showCreateContactoModal, setShowCreateContactoModal] =
		useState(false);
	const [showEditContactoModal, setShowEditContactoModal] = useState(false);
	const [showPINModal, setShowPINModal] = useState(false);
	const [showPINModalCancel, setShowPINModalCancel] = useState(false);
	const [showAgregarPagoModal, setShowAgregarPagoModal] = useState(false);
	const [showCancel, setShowCancel] = useState(false);


	// Opciones de los Dropdown
	const [dropdownOptions, setDropdownOptions] = useState({
		terminos: [],
        productos: [],
		vendedores: [],
		rutas: [],
		grupos: [],
		impuestos: [],
		categorias: [],
        plazos: [],
	});

	const [saving, setSaving] = useState(false);

	// Mutex síncrono contra el doble clic. `saving` es estado de React, así que
	// dos clics en el mismo tick lo ven todavía en false; dispatchEvent corre el
	// onSubmit síncronamente, por lo que un ref seteado antes del primer await sí
	// bloquea el segundo envío.
	const enviandoRef = useRef(false);
	// El path de éxito hace history.push() y desmonta antes de que corra el finally.
	const montadoRef = useRef(true);
	// Intento de guardado en curso: { key, huella, data }. El UUID identifica el
	// intento, no el request, así que sobrevive a los reintentos.
	const intentoRef = useRef(null);

	const [createButtonClicked, setCreateButtonClicked] = useState("normal");
	const [pinSeguridad, setPinSeguridad] = useState("");
	const [pinSeguridadCancel, setPinSeguridadCancel] = useState("");
	const [pagoInfo, setPagoInfo] = useState({
		pago: null,
		tipo_pago: "",
		terminal_tarjeta: "",
		tipo: "",
		banco: "",
		num_aprobacion: "",
		num_cheque: "",
		num_transferencia: "",
		num_deposito: "",
		num_transaccion: "",
        usarRetencion: false,
	});
	const [tipoImpresionAfterPago, setTipoImpresionAfterPago] =
		useState("normal");

	const sumatoriaFinal = useMemo(() => ({
		subtotal: calcularSubtotal(facturaProductos),
		descuento: calcularDescuento(facturaProductos),
		impuestos: calcularImpuestos(facturaProductos),
		exentoGrabado: calcularExentoGrabado(facturaProductos),
		total: !isNaN(calcularTotal(facturaProductos)) ? calcularTotal(facturaProductos) : 0,
	}), [facturaProductos]);

	const totalitbis = useMemo(() => calcularTotalImpuestos(facturaProductos), [facturaProductos]);

	//Para llenar inputs de contacto (Cliente)
	const [contactoInfo, setContactoInfo] = useState({});
	const [facturable, setFacturable] = useState(isEdit ? true : facturaActual.facturable);
	const [esElectronica, setEsElectronica] = useState(facturaActual.esElectronica);

    const resetFacturaProductos = () => {
        setFacturaProductos([
            templateProducto(Date.now())
        ]);
    }

	const toggleCreateContactoModal = async (e, contacto = null) => {
		if (e) e.preventDefault();
		setShowCreateContactoModal((state) => !state);

		if (!contacto || !Object.keys(contacto).includes("id")) return;

        setContactoId(contacto.id);
        changeContactInfo(contacto.id);
        handleInputChange(undefined, 'direccion_entrega')
	};

	const toggleEditContactoModal = (e, contacto = null) => {
		if (e) e.preventDefault();
		setShowEditContactoModal((state) => !state);

		if (!contacto || !Object.keys(contacto).includes("id")) return;

		setContactoId(contacto.id);

		changeContactInfo(contacto.id, false);
	};

	const changeContactInfo = (contacto, clear = true) => {
		if (!contacto) return;

		request(`info-contacto/${contacto}`).then(({ data }) => {
			const vendedor = isVendedor()
				? {
						value: auth.getUser().empleado?.id,
						label: `${auth.getUser().empleado?.codigo} ${
							auth.getUser().empleado?.nombre
						} ${auth.getUser().empleado?.apellido}`,
				  }
				: {
						value: data.vendedor?.id,
						label: `${data.vendedor?.codigo} ${data.vendedor?.nombre} ${data.vendedor?.apellido}`,
				  };

            const contact = {
				...data,
				vendedor: vendedor.value ? vendedor : null,
				ruta: data.ruta
					? { value: data.ruta?.id, label: data.ruta?.nombre }
					: null,
				credito_disponible_actual: parseFloat(data.credito_disponible),
				celular: data.celular ?? '',
				direccion: data.direccion ?? '',
				encargado: data.encargado ?? '',
				telefono: data.telefono ?? '',
				identificacion: data.identificacion ?? '',
			};

			setContactoInfo(contact);

            // Cuando el cliente trae numeración propia esta validación la rehace
            // getComprobanteData con el comprobante recién traído; repetirla aquí
            // con el esElectronica del comprobante anterior duplicaría el toast.
            if (!((clear || fromPlantilla) && contact.numeracion)) {
                if (!contact.identificacion && (esElectronica || facturaActual.comprobante?.electronica)) {
                    setFacturable(false);
                    toast('Este cliente no tiene RNC o Cédula', 'error');
                } else {
                    setFacturable(true);
                }
            }

            if (clear) {
                // Solo la selección de un cliente nuevo puede tocar el comprobante.
                // Con clear=false (editar contacto, restaurar borrador) esta
                // petición resuelve DESPUÉS del setComprobante de setEditInfo, así
                // que escribir aquí le borraba la numeración ya restaurada.
                //
                // Y se pasa por getComprobanteData en vez de armar el objeto a
                // mano: es el único origen que trae prefijo, numero_siguiente
                // reservado, electronica y comprobante_fiscal. contact.numeracion
                // no los tiene, y su `tipo` no es el prefijo del NCF.
                if (contact.numeracion) {
                    getComprobanteData(contact.numeracion.id, contact);
                } else {
                    // El cliente anterior pudo dejar una numeración puesta: si el
                    // nuevo no tiene ninguna asignada, el campo debe quedar vacío.
                    setComprobante({id: ''});
                }

                // El plazo no se preselecciona: el usuario debe elegirlo.
                changePlazo(PLAZO_VACIO);
                resetFacturaProductos();
            } else if (fromPlantilla && contact.numeracion) {
                // La orden/cotización de origen no trae comprobante propio (ver
                // setEditInfo), así que si el cliente tiene numeración configurada
                // se preselecciona igual que al cambiar el contacto manualmente.
                getComprobanteData(contact.numeracion.id, contact);
            }

            aplicarLimiteFecha();
		});
	};

	// Al quitar el cliente se limpia lo que depende de él, igual que al
	// seleccionar uno sin numeración. Los productos se conservan: se reinician
	// de todas formas al elegir el siguiente cliente.
	const clearContacto = () => {
		setContactoId(null);
		setContactoInfo({});
		setFacturable(true);
		setComprobante({id: ''});
		changePlazo(PLAZO_VACIO);
	};

	const plazosDisponibles = useMemo(
		() => plazosParaContacto(dropdownOptions.plazos, contactoInfo),
		[dropdownOptions.plazos, contactoInfo]
	);

	const handleInputChange = (value, field) => {
		setForm((form) => ({
			...form,
			[field]: value,
		}));
	};

	const handleDetalleChange = (value, field) => {
		setContactoInfo((state) => ({ ...state, [field]: value }));
	};

	const aplicarLimiteFecha = () => {
		if (!contactoInfo.plazo) return;

		return dayjs(form.fecha)
			.add(contactoInfo.plazo?.dias, "day")
			.format("YYYY-MM-DD");
	};

	// Funciones para traer data de los dropdowns
	const getDropdownData = () => {
		request("facturas/create").then((res) => {
			setDropdownOptions((options) => ({
				...options,
                productos: res.data?.productos.filter(producto => {
					const almacenes = auth.almacenes();

                    if (auth.is('super-admin') || auth.is('admin') || almacenes.length === 0) return true;
					
                    return almacenes.includes(producto.almacen?.id);
                }),
				rutas: res.data?.rutas,
				terminos: res.data?.terminos,
				comprobantes: res.data?.comprobantes,
				impuestos: res.data?.impuestos,
				categorias: res.data?.categorias,
                plazos: res.data?.terminos,
			}));

            setLoading(false);
		});

		getVendedoresForDropdown().then((data) => {
			setDropdownOptions((options) => ({
				...options,
				vendedores: data.filter((vendedor) => vendedor.value !== ""),
			}));
		});
	};

	// Informacion de comprobantes.
	// `contacto` permite pasar uno recién traído: al llamarse desde
	// changeContactInfo el estado contactoInfo es todavía el del cliente anterior.
	const getComprobanteData = (comprobante, contacto = contactoInfo) => {
		if (!comprobante) return;

		request(`facturas/get-comprobante/${comprobante}`).then((res) => {
			const restantes = res.data.numero_final - res.data.numero_siguiente + 1;
			if (restantes <= 0) {
				toast(
					"No es posible seleccionar esta numeración debido a que no cuenta con números autorizados. Por favor, solicite nuevos números válidos y actualice la información en el menú de numeración.",
					"error"
				);
				setComprobante({ id: "" });
				return;
			}

            setComprobante(res.data);

			if (restantes <= 10) {
				toast(`Usted tiene ${restantes} números disponible`, "error");
			}

			const fechaVencimiento = res.data.fecha_vencimiento;
			if (fechaVencimiento) {
				const dias = dayjs(fechaVencimiento).diff(dayjs(), "day");
				if (dias <= 30) {
					toast(
						dias < 0
							? "La numeración seleccionada ya expiró. Por favor, solicite nuevos números válidos y actualice la información en el menú de numeración."
							: `La numeración seleccionada vence en ${dias} día(s). Por favor, solicite nuevos números válidos y actualice la información en el menú de numeración.`,
						"error"
					);
				}
			}
            if (res.data.electronica) {
                setEsElectronica(true);
            } else {
                setEsElectronica(false);
            }
            if (res.data.electronica && contacto?.id && !contacto.identificacion ) {
                setFacturable(false);
                toast('Este client no tiene RNC o cédula', 'error');
            } else {
                setFacturable(true);
            }
		});
	};

	const updateTotal = (
		id = null,
		subtotal = null,
		total = 0,
		impuestos = 0,
		descuento = 0,
		impuesto = {},
        productoInfo = {},
	) => {
        setFacturaProductos(prev => prev?.map((producto) => {
            if (producto.id !== id) return producto;

            const updated = {
                ...producto,
                producto_id: productoInfo.id,
                importe: subtotal / producto.cantidad,
                descuento,
                subtotal,
                impuestos,
                precios: productoInfo.precios || [],
                producto: productoInfo.producto || {},
                precio_venta: productoInfo.precio_venta,
                total,
                cantidadAnterior: productoInfo.cantidadAnterior,
                unidad: productoInfo.unidadSeleccionada?.value ?? producto.unidad,
                factor: productoInfo.factor ?? 1,
                unidad_id: productoInfo.unidadSeleccionada?.unidad_id ?? null,
            };

            if (impuesto.value) {
                updated.impuesto = impuesto;
            }

            if (productoInfo.precio_manual || productoInfo.precio_venta) {
                updated.precio_facturado = parseFloat(productoInfo.precio_manual ?? productoInfo.precio_venta?.value);
            }

            return updated;
        }));
	};

	const addProducto = () => {
        if (!contactoId) {
            toast('Debe seleccionar un contacto', 'error')
            return;
        }
        setFacturaProductos(prev => [
            ...prev,
            templateProducto(Date.now())
        ])
	};

	const removeProducto = async (index) => {
        setFacturaProductos(prev => prev.filter((i) => i.id !== index));
	};

	const cancel = () => {
        localStorage.removeItem('facturaGuardada');
		history.push(getLink("/ingresos/facturas"));
	};

	const guardarYPagar = () => {
		if(!Object.keys(comprobante).length || !contactoId) {
			toast("Favor completar todos los campos", "error");
			return;
		}
		setShowAgregarPagoModal(true);
	};

	const checkCreditoDisponible = () => {
		if (isVendedor() && isPastDate(facturaActual.fecha)) return true;
		if (
			contactoInfo.credito_disponible_actual <
				sumatoriaFinal.total - form.prevTotal &&
			(plazo.dias > 0 || plazo.dias === null)
		) {
			setShowPINModal(true);
			return false;
		}

		return true;
	};

	const guardarYNuevaFactura = async () => {
		await setCreateButtonClicked("nueva");

		if (!checkCreditoDisponible()) return;

		formRef.current.dispatchEvent(
			new Event("submit", { bubbles: true, cancelable: true })
		);
	};

	const guardarEImprimir = async () => {
		await setCreateButtonClicked("imprimir");

		if (!checkCreditoDisponible()) return;

		formRef.current.dispatchEvent(
			new Event("submit", { bubbles: true, cancelable: true })
		);
	};

	const guardarYSalir = async (btnClick) => {
		if ((!pagoInfo.pago || pagoInfo.pago <= 0 || pagoInfo.pago < facturaActual.por_cobrar) && btnClick === "pagar") {
			toast("El monto debe ser mayor o igual al total de la factura.", "error");
			return;
		}

        if (btnClick === "pagar") {
            const tipoPago = pagoInfo.tipo_pago;

            if (!tipoPago) {
                toast("Debe seleccionar un tipo de pago.", "error");
                return;
            }

            if (!pagoInfo.cuenta) {
                toast("Debe seleccionar una cuenta.", "error");
                return;
            }

            if (['tarjeta', 'tarjeta-debito', 'cheque', 'transferencia'].includes(tipoPago) && !pagoInfo.banco) {
                toast("Debe seleccionar una institución financiera.", "error");
                return;
            }
            if (['tarjeta', 'tarjeta-debito'].includes(tipoPago) && !pagoInfo.terminal_tarjeta) {
                toast("Debe ingresar la terminal de tarjeta.", "error");
                return;
            }
            if (['tarjeta', 'tarjeta-debito'].includes(tipoPago) && !pagoInfo.tipo) {
                toast("Debe seleccionar el tipo de tarjeta.", "error");
                return;
            }
            if (['tarjeta', 'tarjeta-debito'].includes(tipoPago) && !pagoInfo.num_aprobacion) {
                toast("Debe ingresar el número de aprobación.", "error");
                return;
            }
            if (tipoPago === 'cheque' && !pagoInfo.num_cheque) {
                toast("Debe ingresar el número de cheque.", "error");
                return;
            }
            if (tipoPago === 'transferencia' && !pagoInfo.num_transferencia) {
                toast("Debe ingresar el número de transferencia.", "error");
                return;
            }
            if (tipoPago === 'deposito' && !pagoInfo.num_deposito) {
                toast("Debe ingresar el número de depósito.", "error");
                return;
            }
            if (tipoPago === 'otro' && !pagoInfo.num_transaccion) {
                toast("Debe ingresar el número de transacción.", "error");
                return;
            }
        }

		await setCreateButtonClicked(btnClick);

		if (!checkCreditoDisponible()) {
			return;
		}
		formRef.current.dispatchEvent(
			new Event("submit", { bubbles: true, cancelable: true })
		);
	};

    const condicionPago = () => {
        if (parseFloat(pagoInfo.pago) < parseFloat(sumatoriaFinal.total) || parseFloat(pagoInfo.pago) <= 0) {
            setPagoInfo((state) => ({ ...state, pago: '' }));
            toast('El monto debe ser mayor o igual al total de la factura.', 'error');
            return false;
        }

        return true;
    }

	/**
	 * Prepara el intento de guardado y decide si reusa o renueva el
	 * Idempotency-Key.
	 *
	 * La regla del spec es "regenerar solo cuando el usuario modifica el
	 * formulario". No se implementa detectando ediciones, sino derivando la
	 * igualdad del contenido: se compara una huella del FormData. Detectar
	 * ediciones sobre-invalidaría, porque el propio formulario muta su estado sin
	 * intervención del usuario (ver el efecto que recalcula contactoInfo cuando
	 * cambia sumatoriaFinal.total), y una key nueva en el reintento es
	 * exactamente el duplicado que estamos evitando.
	 *
	 * El FormData se cachea junto a la key: los reintentos reenvían ese mismo
	 * objeto, porque el backend hashea el payload y responde 422 si cambia.
	 */
	const prepararIntento = (formEl) => {
		const data = new FormData(formEl);

		// Se agrega al FormData nuevo, nunca al cacheado: si no, un reintento
		// mandaría _method dos veces.
		if (isEdit) data.append("_method", "put");

		const huella = huellaFormData(data);

		if (!intentoRef.current || intentoRef.current.huella !== huella) {
			intentoRef.current = { key: generarUUID(), huella, data };
		}

		return intentoRef.current;
	};

	const efectosExitoCrear = (response) => {
		if (createButtonClicked === "normal") {
			history.push(getLink("/ingresos/facturas"));
		} else if (
			createButtonClicked === "pagar" ||
			createButtonClicked === "imprimir"
		) {
			if (tipoImpresionAfterPago === "doble") {
				window.open(
					getLink(
						`/imprimir/facturas/${response.data.factura}/doble`
					)
				);
			} else {
                window.open(
                    getLink(`/imprimir/facturas/${response.data.factura}`)
                );
            }
			history.push(getLink("/ingresos/facturas"));
		}
		resetFields();
	};

	const efectosExitoEditar = (response) => {
		if (createButtonClicked === "normal") {
			history.push(getLink("/ingresos/facturas"));
		} else if (
			createButtonClicked === "pagar" ||
			createButtonClicked === "imprimir"
		) {
			history.push(getLink("/ingresos/facturas"));
			window.open(
				getLink(`/imprimir/facturas/${response.data?.factura}`)
			);
		}
		resetFields();
	};

	/**
	 * El status autoritativo es el HTTP (r.status); el `code` del cuerpo queda
	 * como respaldo. La key solo se descarta al confirmarse el éxito (y en el 422
	 * de clave reusada, que es el único caso que podría quedar en bucle).
	 */
	const manejarRespuestaGuardado = (r) => {
		// Nunca hubo respuesta. Se conserva la key: reintentar con ella no duplica.
		if (!r || r.status === 0) {
			const abortado = r && r.tipoError === "abortado";

			setErrorGeneral({
				tipo: "red",
				mensaje: abortado
					? "La conexión tardó demasiado. Es posible que la factura sí se haya guardado. Puede presionar Guardar de nuevo: no se creará una factura duplicada."
					: "No se pudo contactar el servidor. Puede presionar Guardar de nuevo: no se creará una factura duplicada.",
			});
			toast(
				abortado ? "Tiempo de espera agotado" : "Error de conexión",
				"error"
			);
			return;
		}

		const cuerpo = r.body || {};
		const codigo = r.status || cuerpo.code;
		const mensaje = cuerpo.data && cuerpo.data.message;

		if (r.ok && cuerpo.success) {
			// Único punto donde se descarta la key.
			intentoRef.current = null;
			localStorage.removeItem("facturaGuardada");
			setFacturaGuardada(undefined);

			// Cross-origin este header puede venir null si el backend no lo expone;
			// solo cambia el texto del toast, nunca la lógica: el cuerpo del replay
			// es la respuesta original con el mismo data.factura.
			const esReplay =
				r.headers &&
				typeof r.headers.get === "function" &&
				r.headers.get("Idempotent-Replay") === "true";

			toast(
				esReplay
					? "Esta factura ya estaba registrada"
					: isEdit
					? "Factura actualizada"
					: "Factura creada",
				"success"
			);

			isEdit ? efectosExitoEditar(cuerpo) : efectosExitoCrear(cuerpo);
			return;
		}

		// Guardado en curso con esa key. No es un fallo y no se reintenta.
		if (codigo === 409) {
			setErrorGeneral({
				tipo: "enProceso",
				mensaje:
					(typeof mensaje === "string" && mensaje) ||
					"El guardado ya está en proceso. Espere la confirmación.",
			});
			toast("El guardado está en proceso...", "warning");
			return;
		}

		if (codigo === 422) {
			if (mensaje && typeof mensaje === "object" && !Array.isArray(mensaje)) {
				// Error de negocio (stock, numeración). El backend liberó la key; si
				// el usuario corrige algo la huella cambia sola y se acuña una nueva.
				const mapa = normalizarErrores(mensaje);
				setErrors(mapa);
				toast(
					Object.keys(mapa)
						.map((k) => mapa[k].join(", "))
						.join(" | ") || "Favor revisar todos los campos",
					"error"
				);
				return;
			}

			// Misma key con payload distinto: nuestra huella dijo "igual" y el hash
			// del servidor dijo "distinto". Es el único estado capaz de quedar en
			// bucle, así que se fuerza una key nueva.
			intentoRef.current = null;
			setErrorGeneral({
				tipo: "validacion",
				mensaje:
					typeof mensaje === "string"
						? mensaje
						: "Favor revisar todos los campos",
			});
			toast(
				typeof mensaje === "string"
					? mensaje
					: "Favor revisar todos los campos",
				"error"
			);
			return;
		}

		// 400 / 500 / cualquier otro. Se conserva la key: el backend la liberó y no
		// se guardó nada, así que reintentar con ella es correcto.
		setErrorGeneral({
			tipo: "servidor",
			mensaje:
				typeof mensaje === "string"
					? mensaje
					: "Ocurrió un error guardando la factura.",
			referencia: cuerpo.data && cuerpo.data.referencia,
		});
		toast(
			typeof mensaje === "string"
				? mensaje
				: "Ocurrió un error guardando la factura.",
			"error"
		);
	};

	const guardarFactura = async (event) => {
		event.preventDefault();

		if (enviandoRef.current) return;
		enviandoRef.current = true;

		setErrors({});
		setErrorGeneral(null);
		setSaving(true);

		const intento = prepararIntento(event.target);
		// Copias locales: el intento en el ref puede cambiar mientras este request
		// está en vuelo.
		const llave = intento.key;
		const cuerpo = intento.data;
		const url = isEdit ? `facturas/${facturaActual.id}` : "facturas";

		const controlador = new AbortController();
		const temporizador = setTimeout(
			() => controlador.abort(),
			TIEMPO_LIMITE_GUARDADO
		);

		try {
			const response = await apiRequest(cuerpo, url, "POST", {
				headers: { "Idempotency-Key": llave },
				raw: true,
				silencioso: true,
				signal: controlador.signal,
			});

			manejarRespuestaGuardado(response);
		} finally {
			clearTimeout(temporizador);
			enviandoRef.current = false;
			if (montadoRef.current) setSaving(false);
		}
	};

	const resetFields = () => {
		setCreateButtonClicked("normal");
		setErrorGeneral(null);
		setContactoInfo({});
		setForm({
			fecha: dayjs().format("YYYY-MM-DD"),
			fecha_vencimiento: dayjs().format("YYYY-MM-DD"),
			notas: "",
			categorias: [],
		});

        setErrors({});
        setComprobante({id: ''});
        setContactoId(null);
        resetFacturaProductos();
        changePlazo(PLAZO_VACIO);
		setPagoInfo({
			pago: null,
			tipo_pago: null,
            usarRetencion: false,
		});

		setPinSeguridad("");
		setPinSeguridadCancel("");
		window.scrollTo(0, 0);
	};

    const mostrarPago = (mostrar) => {
        setShowAgregarPagoModal(mostrar);
        setPagoInfo({
			pago: null,
			tipo_pago: null,
            usarRetencion: false,
		});
    }

	const checkPINSeguridad = async () => {
		if (await validarPINSeguridad(pinSeguridad)) {
			setPinSeguridad("");
			setShowPINModal(false);
			formRef.current.dispatchEvent(
				new Event("submit", { bubbles: true, cancelable: true })
			);
			return;
		}

		toast("PIN incorrecto, intente de nuevo", "error");
	};

	const checkPINSeguridadCancel = async () => {
		if (await validarPINSeguridad(pinSeguridadCancel)) {
			setPinSeguridadCancel("");
			setShowPINModalCancel(false);
			toggleCancelModal();
			return;
		}

		toast("PIN incorrecto, intente de nuevo", "error");
	};

	const toggleCancelModal = () => {
		setShowCancel((state) => !state);
	};

	// Sin Idempotency-Key a propósito: comparte la URL con el update pero el
	// backend solo protege store y update, no el destroy.
	const cancelFactura = async (facturaID) => {
        if (!razonCancelacion) {
            toast('Favor seleccionar el motivo de la cancelación.', 'error');
            return;
        }

		if (enviandoRef.current) return;
		enviandoRef.current = true;

		setShowCancel((state) => !state);
        setErrors({});
        setErrorGeneral(null);

		setSaving(true);

        const data = new FormData();

		data.append("_method", 'DELETE');
		data.append("razon_estado", razonCancelacion);

		try {
			const response = await apiRequest(
				data,
				`facturas/${facturaID}`,
	            'POST'
			);

			if (response && response.success) {
				toast("Factura Cancelada", "success");
				history.push(getLink("/ingresos/facturas"));
				return;
			}
			toast("Error cancelando factura", "error");
		} finally {
			enviandoRef.current = false;
			if (montadoRef.current) setSaving(false);
		}
	};

	const setPorPagar = () => {
        setPagoInfo((state) => ({
            ...state,
            pago: parseFloat(sumatoriaFinal.total),
        }));
	};

	const setEditInfo = async () => {
		await setContactoInfo({
			...facturaActual.cliente,
			vendedor: facturaActual.vendedor
				? {
						value: facturaActual.vendedor?.id || facturaActual.vendedor?.value,
						label: facturaActual.vendedor?.nombre ? `${facturaActual.vendedor.nombre} ${facturaActual.vendedor.apellido}` : facturaActual.vendedor?.label,
				  }
				: null,
			ruta: facturaActual.ruta
				? {
						value: facturaActual.ruta?.id || facturaActual.ruta?.value,
						label: facturaActual.ruta?.nombre || facturaActual.ruta?.label,
				  }
				: null,
			credito_disponible_actual: parseFloat(
				facturaActual.cliente?.credito_disponible
			),
		});

        setFacturaProductos(facturaActual.productos);

        setContactoId(facturaActual.cliente?.id);
        changeContactInfo(facturaActual.cliente?.id, false);

        setComprobante(fromPlantilla
            ? { prefijo: null, numero_siguiente: null }
            : {
                    ...facturaActual.comprobante,
                    prefijo:
                        facturaActual.numero_comprobante?.substring(0, 3) ||
                        "",
                    id:
                        facturaActual.comprobante?.id,
                    numero_siguiente:
                        facturaActual.numero_comprobante?.substring(
                            3,
                            12
                        ) || "",
              });

        changePlazo({
            value: facturaActual.plazo?.id || facturaActual.plazo?.value,
            label: facturaActual.plazo?.nombre || facturaActual.plazo?.label,
            dias: facturaActual.plazo?.dias,
        });

		setForm((form) => ({
			...form,
			fecha: fromPlantilla
				? dayjs().format("YYYY-MM-DD")
				: dayjs(facturaActual.fecha).format("YYYY-MM-DD"),
			fecha_vencimiento: dayjs(facturaActual.fecha_vencimiento).format(
				"YYYY-MM-DD"
			),
			notas: facturaActual.notas,
			categorias:
				facturaActual.categorias &&
				facturaActual.categorias?.map((c) => ({
					label: c.nombre,
					value: c.id,
				})),
			prevTotal: facturaActual.total || 0,
			porCobrar: facturaActual.porCobrar || 0,
			direccion_entrega: facturaActual.direccion_entrega || undefined,
		}));
	};

    const changePlazo = (plazo) => {
        if (!plazo) return;

        let vencimiento = dayjs(form.fecha);

        setPlazo(plazo);

        if (form.fecha) {
            if (plazo.dias === null) return;

            vencimiento = vencimiento.add(plazo.dias, "day");

            handleInputChange(
                vencimiento.format("YYYY-MM-DD"),
                "fecha_vencimiento"
            );
        }
    }

	const isComprobanteFiscal = () => {
		return (
			comprobante?.comprobante_fiscal?.includes("B01") ||
			comprobante?.comprobante_fiscal?.includes("B02") ||
			comprobante?.comprobante_fiscal?.includes("B14") ||
			comprobante?.comprobante_fiscal?.includes("B15") ||
			comprobante?.comprobante_fiscal?.includes("B16")
		);
	};

	useEffect(() => {
		if (!contactoInfo.credito_disponible_actual) return;
		setContactoInfo(state => ({
			...state,
			credito_disponible: money(
				state.credito_disponible_actual - (sumatoriaFinal.total - form.prevTotal)
			),
		}));
	}, [sumatoriaFinal.total, form.prevTotal]);

	useEffect(() => {
		// Sin cliente no hay borrador que valga la pena guardar. Además evita que
		// resetFields() reescriba la key justo después de borrarla en el éxito, lo
		// que hacía que Create.js ofreciera restaurar un borrador vacío.
		//
		// A propósito NO se agrega contactoId al arreglo de dependencias: solo debe
		// actuar como guardia cuando el efecto ya dispara por otro motivo. Si
		// contactoId disparara por sí solo, se dispararía en medio de setEditInfo()
		// (contactoId se setea antes que comprobante al restaurar un borrador),
		// persistiendo un comprobante todavía vacío y perdiendo la numeración
		// seleccionada.
		if (!contactoId) return;

		setFacturaGuardada(prev => ({
			...prev,
			cliente: contactoInfo.id ? contactoInfo : prev?.cliente,
			vendedor: contactoInfo.vendedor,
			ruta: contactoInfo.ruta,
			fecha: form.fecha,
			fecha_vencimiento: form.fecha_vencimiento,
			notas: form.notas,
			categorias: Array.isArray(form.categorias)
				? form.categorias.map(c => ({ id: c.value, nombre: c.label }))
				: form.categorias,
			direccion_entrega: form.direccion_entrega,
			comprobante,
			numero_comprobante:
				comprobante.prefijo != null && comprobante.numero_siguiente != null
					? comprobante.prefijo + comprobante.numero_siguiente
					: prev?.numero_comprobante,
			productos: facturaProductos?.map(p => ({
				...p,
				impuesto_id: p.impuesto?.value,
				impuesto: p.impuesto
					? {
							id: p.impuesto?.value,
							nombre: p.impuesto?.label,
							porcentaje: p.impuesto?.porcentaje,
							tipo: p.impuesto?.tipo,
					  }
					: null,
			})),
			plazo
		}));
	}, [contactoInfo, form, comprobante, facturaProductos, plazo]);

	useEffect(() => {
		getDropdownData();
	}, []);

	useEffect(() => () => {
		montadoRef.current = false;
	}, []);

	useEffect(() => {
		if (Object.keys(facturaActual).length <= 0) return;
		if (!isEdit && !fromPlantilla && !isRecovery) return;
		setEditInfo();
        if(!isEdit && !facturaActual.facturable) {
            setFacturable(false);
        }
	}, [facturaActual, facturaActual?.productos]);

	if (loading) {
		return <Loader />;
	}

	return (
		<>
			{/*
			  Todo <button> dentro de este form es type="button" a propósito: sin
			  botón de submit y con más de un campo, Enter no envía el formulario.
			  Agregar un <button> sin type convertiría Enter en un guardado.
			*/}
			<form
				method="post"
				onSubmit={guardarFactura}
				ref={formRef}
			>
                {!fromPlantilla && (
                    <>
                        <input
                            type="hidden"
                            name="id"
                            value={facturaActual.id}
                        />
                        <input
                            type="hidden"
                            name="recurrencia_id"
                            value={facturaActual.recurrencia_id}
                        />
                    </>
                )}
                {fromPlantilla && (
                    <>
                        {fromOrden === "si" ? (
                            <input
                                type="hidden"
                                name="orden_id"
                                value={facturaActual.id}
                            />
                        ) : (
                            <input
                                type="hidden"
                                name="cotizacion_id"
                                value={facturaActual.id}
                            />
                        )}
                    </>
                )}
				<div className="crear-compra">
					<div className="page-controls">
						<Detalles
							form={form}
							contactoInfo={contactoInfo}
							contactoId={contactoId}
                            setContactoId={setContactoId}
							plazo={plazo}
                            changePlazo={changePlazo}
                            plazosDisponibles={plazosDisponibles}
							dropdownOptions={dropdownOptions}
							toggleCreateContactoModal={
								toggleCreateContactoModal
							}
							toggleEditContactoModal={toggleEditContactoModal}
							handleInputChange={handleInputChange}
							getComprobanteData={getComprobanteData}
							comprobante={comprobante}
							aplicarLimiteFecha={aplicarLimiteFecha}
							handleDetalleChange={handleDetalleChange}
							isComprobanteFiscal={isComprobanteFiscal}
                            changeContactInfo={changeContactInfo}
                            clearContacto={clearContacto}
							isEdit={isEdit}
                            isRecovery={isRecovery}
                            errors={errors}
						/>
					</div>
					<div className="col-md-12 p-0">
						{window.screen.width <= 992 ? (
							<div className="d-block d-lg-none">
								{facturaProductos?.map(
										(producto, index) => (
											<ProductosFacturaMobile
												key={producto.id}
												producto={producto}
												index={index}
												removeProducto={removeProducto}
												updateTotal={updateTotal}
                                                productos={
                                                    dropdownOptions.productos
                                                }
												precioLimite={
													contactoInfo.precio_venta
												}
												banderaContacto={
													contactoInfo.bandera
												}
												impuestosForDropdown={
													dropdownOptions.impuestos
												}
												facturaProductos={
													facturaProductos
												}
												isEdit={isEdit}
                                                isRecovery={isRecovery}
                                                fromPlantilla={fromPlantilla}
												errors={errors}
												contacto={contactoInfo.id}
											/>
										)
									)}
								{errors.productos && (
									<small className="help-blockParams form-Text">
										{errors.productos[0]}
									</small>
								)}
								<div className="d-flex justify-content-end mb-3">
									<button
										type="button"
										onClick={addProducto}
										className="btn"
										style={{
											border: "1px solid #FE9D1F",
											color: "#6c757d",
										}}
									>
										<i className="fas fa-plus" /> Agregar
										Producto
									</button>
								</div>

                                {sumatoriaFinal.descuento > 0 && <div className="row px-4 justify-content-between">
									<strong className="label form-control-label">
										Descuento:
									</strong>
									<span>
										-
										{formatCurrency(
											money(sumatoriaFinal.descuento)
										)}
									</span>
								</div>}

								<div className="row px-4 justify-content-between">
									<strong className="label form-control-label">
										Subtotal:
									</strong>
									<span>
										{formatCurrency(
											money(sumatoriaFinal.subtotal)
										)}
									</span>
								</div>

                                {sumatoriaFinal?.exentoGrabado?.Exento > 0 && Object.keys(sumatoriaFinal.exentoGrabado).filter(k => ['Exento', 'Grabado'].includes(k)).map(
									(impuesto, index) => (
										<div
											className="row px-4 justify-content-between"
											key={index}
										>
											<strong className="label form-control-label">
												{impuesto}
											</strong>

											{formatCurrency(
												money(
													sumatoriaFinal.exentoGrabado[
														impuesto
													]
												)
											)}
										</div>
									)
								)}

								{Object.keys(sumatoriaFinal.impuestos).map(
									(impuesto, index) => (
										<div
											className="row px-4 justify-content-between"
											key={index}
										>
											<strong className="label form-control-label">
												{impuesto}
											</strong>

											{formatCurrency(
												money(
													sumatoriaFinal.impuestos[
														impuesto
													]
												)
											)}
										</div>
									)
								)}

                                <input
                                    type="hidden"
                                    name="subtotal"
                                    value={sumatoriaFinal.subtotal || 0}
                                    readOnly
                                />
                                <input
                                    type="hidden"
                                    name="impuestos"
                                    value={totalitbis}
                                    readOnly
                                />
                                <input
                                    type="hidden"
                                    name="descuento"
                                    value={
                                        sumatoriaFinal?.descuento || 0
                                    }
                                    readOnly
                                />
                                <input
                                    type="hidden"
                                    name="pagado"
                                    value="0"
                                    readOnly
                                />
                                <input
                                    type="hidden"
                                    name="total"
                                    value={money(sumatoriaFinal.total)}
                                    readOnly
                                />

								<div className="row px-4 justify-content-between">
									<strong className="label form-control-label">
										Total:
									</strong>
									<span>
										{formatCurrency(
											money(sumatoriaFinal.total)
										)}
									</span>
								</div>
							</div>
						) : (
                            <table className="table d-none d-lg-table">
							<thead>
								<tr>
									<th width="170px">REF./CÓDIGO</th>
									<th width="23%">Producto</th>
									<th width="85px">Cant.</th>
									<th width="85px">Unidad</th>
									<th width="9%">Importe</th>
									<th width="160px">Impuesto</th>
									<th width="180px">Precio</th>
									<th width="78px">% Desc.</th>
									<th className="text-right" width="9%">
										Total
									</th>
									<th className="text-center" width="5%">
										Fotos
									</th>
									<th width="85px"></th>
								</tr>
							</thead>
							<tbody>
								{facturaProductos?.map(
									(producto, index) => (
										<ProductosFactura
											key={producto.id}
                                            productos={dropdownOptions.productos}
											producto={producto}
											index={index}
											removeProducto={removeProducto}
											updateTotal={updateTotal}
											grupos={dropdownOptions.grupos}
											precioLimite={
												contactoInfo.precio_venta
											}
											banderaContacto={
												contactoInfo.bandera
											}
											impuestosForDropdown={
												dropdownOptions.impuestos
											}
											facturaProductos={
												facturaProductos
											}
											isEdit={isEdit}
                                            isRecovery={isRecovery}
                                            fromPlantilla={fromPlantilla}
											errors={errors}
											contacto={contactoInfo.id}
										/>
									)
								)}
								<tr>
									<td colSpan="11">
										{errors["productos"] && (
											<small className="help-blockParams form-Text">
												{errors["productos"][0]}
											</small>
										)}
									</td>
								</tr>
								<tr>
									<td
										colSpan="11"
										style={{ border: 0, paddingTop: 0 }}
										className="text-right"
									>
										<button
											type="button"
											onClick={addProducto}
											className="btn"
										>
											<i className="fas fa-plus" />{" "}
											Agregar Producto
										</button>
									</td>
								</tr>
                                {sumatoriaFinal?.descuento > 0 && (
                                    <tr>
                                        <td colSpan="9" className="text-right">
                                            <strong className="label form-control-label">
                                                Descuento:
                                            </strong>
                                        </td>
                                        <td colSpan="2" className="text-right">
                                            - {formatCurrency(
                                                money(sumatoriaFinal?.descuento)
                                            )}
                                        </td>
                                    </tr>
                                )}
								<tr>
									<td colSpan="9" className="text-right">
										<strong className="label form-control-label">
											Subtotal:
										</strong>
									</td>
									<td colSpan="2" className="text-right">
										<input
											type="hidden"
											name="subtotal"
											value={sumatoriaFinal.subtotal || 0}
											readOnly
										/>
                                        <input
                                            type="hidden"
                                            name="impuestos"
                                            value={totalitbis}
                                            readOnly
                                        />
                                        <input
                                            type="hidden"
                                            name="descuento"
                                            value={
                                                sumatoriaFinal?.descuento || 0
                                            }
                                            readOnly
                                        />
										{formatCurrency(
											money(sumatoriaFinal.subtotal)
										)}
									</td>
								</tr>
                                {sumatoriaFinal?.exentoGrabado?.Exento && Object.keys(sumatoriaFinal.exentoGrabado).filter(k => ['Exento', 'Grabado'].includes(k)).map(
									(impuesto, index) => (
										<tr key={index}>
											<td
												colSpan="9"
												className="text-right"
											>
												<strong className="label form-control-label">
													{impuesto}
												</strong>
											</td>
											<td
												colSpan="2"
												className="text-right"
											>
												{formatCurrency(
													money(
														sumatoriaFinal
															.exentoGrabado[impuesto]
													)
												)}
											</td>
										</tr>
									)
								)}
								{Object.keys(sumatoriaFinal.impuestos).map(
									(impuesto, index) => (
										<tr key={index}>
											<td
												colSpan="9"
												className="text-right"
											>
												<strong className="label form-control-label">
													{impuesto}
												</strong>
											</td>
											<td
												colSpan="2"
												className="text-right"
											>
												{formatCurrency(
													money(
														sumatoriaFinal
															.impuestos[impuesto]
													)
												)}
											</td>
										</tr>
									)
								)}
								<tr>
									<td colSpan="9" className="text-right">
										<strong className="label form-control-label">
											Total:
										</strong>
									</td>
									<td colSpan="2" className="text-right">
										<input
											type="hidden"
											name="pagado"
											value="0"
											readOnly
										/>
										<input
											type="hidden"
											name="total"
											value={money(sumatoriaFinal.total)}
											readOnly
										/>
										{formatCurrency(
											money(sumatoriaFinal.total)
										)}
									</td>
								</tr>
                                {errors.total && (
                                    <tr>
                                        <td colSpan="11" className="text-right">
                                            {errors.total && (
                                                <small className="help-blockParams form-Text">
                                                    {errors.total[0]}
                                                </small>
                                            )}
                                        </td>
                                    </tr>
                                )}
							</tbody>
						</table>
                        )}
						<hr />
					</div>

                    <div className="col-md-12 d-none">
                        <table className="table">
                            <thead>
                                <tr>
                                    <td><small>ITBIS 16%</small></td>
                                    <td><small>ITBIS 18%</small></td>
                                    <td><small>GRABADO ITBIS 16%</small></td>
                                    <td><small>GRABADO ITBIS 18%</small></td>
                                    <td><small>EXENTO</small></td>
                                    <td><small>GRABADO</small></td>
                                    <td><small>IMPUESTO TOTAL</small></td>
                                    <td><small>DESCUENTO</small></td>
                                    <td><small>SUBTOTAL</small></td>
                                    <td><small>TOTAL</small></td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {money(sumatoriaFinal?.impuestos['ITBIS 16%'])}
                                        <input type="hidden" name="sumatoria[ITBIS 16%]" value={money(sumatoriaFinal?.impuestos['ITBIS 16%'])} />
                                    </td>
                                    <td>
                                        {money(sumatoriaFinal?.impuestos['ITBIS 18%'])}
                                        <input type="hidden" name="sumatoria[ITBIS 18%]" value={money(sumatoriaFinal?.impuestos['ITBIS 18%'])} />
                                    </td>
                                    <td>
                                        {money(sumatoriaFinal?.exentoGrabado['ITBIS 16%'])}
                                        <input type="hidden" name="sumatoria[Grabado ITBIS 16%]" value={money(sumatoriaFinal?.exentoGrabado['ITBIS 16%'])} />
                                    </td>
                                    <td>
                                        {money(sumatoriaFinal?.exentoGrabado['ITBIS 18%'])}
                                        <input type="hidden" name="sumatoria[Grabado ITBIS 18%]" value={money(sumatoriaFinal?.exentoGrabado['ITBIS 18%'])} />
                                    </td>
                                    <td>
                                        {money(sumatoriaFinal?.exentoGrabado['Exento'])}
                                        <input type="hidden" name="sumatoria[Exento]" value={money(sumatoriaFinal?.exentoGrabado['Exento'])} />
                                    </td>
                                    <td>
                                        {money(sumatoriaFinal?.exentoGrabado['Grabado'])}
                                        <input type="hidden" name="sumatoria[Grabado]" value={money(sumatoriaFinal?.exentoGrabado['Grabado'])} />
                                    </td>
                                    <td>
                                        {money(totalitbis)}
                                        <input type="hidden" name="sumatoria[Total ITBIS]" value={money(totalitbis)} />
                                    </td>
                                    <td>
                                        {money(sumatoriaFinal.descuento)}
                                        <input type="hidden" name="sumatoria[Descuento]" value={money(sumatoriaFinal.descuento)} />
                                    </td>
                                    <td>
                                        {money(sumatoriaFinal.subtotal)}
                                        <input type="hidden" name="sumatoria[Subtotal]" value={money(sumatoriaFinal.subtotal)} />
                                    </td>
                                    <td>
                                        {money(sumatoriaFinal.total)}
                                        <input type="hidden" name="sumatoria[Total]" value={money(sumatoriaFinal.total)} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

					<div className="col-md-12">
                        <div className="row">
							<div
								className="form-group col-md-6"
								style={{ marginBottom: "0.3rem" }}
							>
								{facturaActual.facturaFirmada?.length > 0 ? (
												<label className="label form-control-label">
													Factura Firmada en PDF:
												</label>
											) : (
												<label className="label form-control-label">
													Adjuntar Factura Firmada:
												</label>
											)}
											<FileLoader
												name="factura_firmada[]"
												archivos={facturaActual.facturaFirmada ?? []}
											/>
											{errors.facturaFirmada && (
												<small className="help-blockParams form-Text">
													{errors.facturaFirmada[0]}
												</small>
											)}
							</div>
							<div
								className="form-group col-md-6"
								style={{ marginBottom: "0.3rem" }}
							>
								<label className="label form-control-label">
									notas:
								</label>
								<textarea
									className="text-input form-control"
									id="notas"
									name="notas"
									rows={4}
									value={form.notas}
                                    onChange={e => handleInputChange(e.target.value, 'notas')}
								/>
								{errors.notas && (
									<small className="help-blockParams form-Text">
										{errors.notas[0]}
									</small>
								)}
							</div>

							{form?.direccion_entrega && <div className="form-group col-md-12" style={{ marginBottom: "0.3rem" }}>
								<input type="hidden" name="direccion_entrega[direccion]" value={form.direccion_entrega.direccion} />
								<input type="hidden" name="direccion_entrega[ubicacion]" value={form.direccion_entrega.ubicacion} />

								<label className="label form-control-label">
									Dirección Entrega:
								</label>

								<div style={{ padding: "0.375rem 0.75rem", color: "#495057", backgroundColor: "#fff", border: "ipx solid #ced4da", borderRadius: "0.25rem" }}>
									{form.direccion_entrega.direccion}
								</div>
							</div>}
						</div>
					</div>
					{/* Precede a ambos footers para que se vea en desktop y en móvil */}
					{errorGeneral && (
						<div
							className={`alert ${
								errorGeneral.tipo === "enProceso"
									? "alert-warning"
									: "alert-danger"
							}`}
							role="alert"
						>
							<strong>
								{errorGeneral.tipo === "enProceso"
									? "Guardado en proceso"
									: "No se pudo guardar"}
							</strong>
							<div>{errorGeneral.mensaje}</div>
							{errorGeneral.referencia && (
								<div className="mt-1">
									<small>
										Referencia para soporte:{" "}
										<code>{errorGeneral.referencia}</code>
									</small>
								</div>
							)}
						</div>
					)}
					{errors.id && (
						<div className="mb-2">
							<small className="help-blockParams form-Text">
								{errors.id[0]}
							</small>
						</div>
					)}
					{/* DESKTOP FOOTER */}
					<div className="page-footer d-none d-lg-block text-right">
						<button
							type="button"
							onClick={cancel}
							className="btn btn-plain"
						>
							Descartar
						</button>
                        {isEdit && (
                            <>
                                {!saving && (
                                    <button
                                        type="button"
                                        onClick={() => setShowPINModalCancel((state) => !state)}
                                        className="btn btn-outline-danger mr-2"
                                    >
                                        Cancelar Factura
                                    </button>
                                )}
                            </>
                        )}

                        {(canSaveAndPay(isEdit, saving, form.fecha, (form.porCobrar !== form.prevTotal), fromOrden) && plazo.label === "Contado") && (
                            <button
                                type="button"
                                onClick={() => guardarYPagar()}
                                className="btn btn-outline-primary mr-2"
                                disabled={!facturable}
                            >
                                Guardar y agregar pago
                            </button>
                        )}

                        {!isEdit && !saving && plazo.label !== "Contado" && (
                            <>
                                <button
                                    type="button"
                                    onClick={() => guardarYNuevaFactura()}
                                    disabled={!facturable}
                                    className="btn btn-outline-primary mr-2"
                                >
                                    Guardar y crear nueva
                                </button>
                            </>
                        )}

                        {!saving && plazo.label !== "Contado" && (
                            <>
                                <button
                                    type="button"
                                    onClick={() => guardarEImprimir()}
                                    disabled={!facturable}
                                    className="btn btn-outline-primary mr-2"
                                >
                                    Guardar e imprimir
                                </button>
                            </>
                        )}
						{!saving && plazo.label !== "Contado" && (
							<button
								type="button"
								onClick={() => guardarYSalir("normal")}
                                disabled={!facturable}
								className="btn btn-primary"
							>
								Guardar
							</button>
						)}
                        {saving && (
							<Loader type="small" />
						)}
					</div>
					{/* MOBILE FOOTER */}
					<div className="page-footer d-block d-lg-none text-right">
                        {!saving && plazo.label !== "Contado" && (
                            <div className="row justify-content-center mb-2">
                                {saving ? (
                                    <Loader type="small" />
                                ) : (
                                    <button
                                        type="button"
                                        onClick={() => guardarEImprimir()}
                                        className="btn btn-primary col-11 ml-0"
                                        disabled={!facturable}
                                    >
                                        Guardar e imprimir
                                    </button>
                                )}
                            </div>
                        )}

						<div className="row justify-content-around">
							{!saving && plazo.label !== "Contado" && (
								<>
									<button
										type="button"
										onClick={() => guardarYSalir("normal")}
										className="btn btn-outline-primary col-11 col-sm-5 mb-2 ml-0"
                                        disabled={!facturable}
									>
										Guardar
									</button>
								</>
							)}
							{isEdit && (
								<>
									{!saving && (
										<button
											type="button"
											onClick={() => setShowPINModalCancel((state) => !state)}
											className="btn btn-outline-danger col-11 col-sm-5 ml-0 mb-2"
                                            disabled={!facturable}
										>
											Cancelar Factura
										</button>
									)}
								</>
							)}
							{!isEdit && !saving && plazo.label !== "Contado" && (
								<>
									<button
										type="button"
										onClick={() => guardarYNuevaFactura()}
										className="btn btn-outline-primary col-11 col-sm-5 mb-2 ml-0"
                                        disabled={!facturable}
									>
										Guardar y crear nueva
									</button>
								</>
							)}
						</div>
						<div className="row justify-content-around">
							{canSaveAndPay(isEdit, saving, form.fecha, false, fromOrden) && plazo.label === "Contado" && (
								<button
									type="button"
									onClick={() => guardarYPagar()}
									className="btn btn-outline-primary col-11 col-sm-5 ml-0"
                                    disabled={!facturable}
								>
									Guardar y agregar pago
								</button>
							)}
							<button
								type="button"
								onClick={cancel}
								className="btn btn-plain col-11 col-sm-5 ml-0 mt-3"
							>
								Descartar
							</button>
						</div>
					</div>
					{/* <---PIN DE SEGURIDAD MODAL--- */}
					<Modal
						title="PIN de seguridad"
						show={showPINModal}
						callback={() => checkPINSeguridad()}
						acceptText="Aceptar"
						toggle={() => setShowPINModal((state) => !state)}
						size="419px"
					>
						<div className="form-group">
							<label>PIN de seguridad</label>
							<input
								type="password"
								className="form-control"
								id="PIN"
								name="pin_seguridad"
								value={pinSeguridad}
								onChange={(e) =>
									setPinSeguridad(e.target.value)
								}
							/>
							<p
								className="font-weight-bold"
								style={{
									color: "gray",
									fontStyle: "italic",
									lineHeight: "13px",
									fontSize: "0.7rem",
								}}
							>
								El cliente no cuenta con credito suficiente.
								Para continuar ingrese PIN de seguridad
							</p>
						</div>
					</Modal>
					{/* <---PIN DE SEGURIDAD MODAL Cancel--- */}
					<Modal
						title="PIN de seguridad"
						show={showPINModalCancel}
						callback={() => checkPINSeguridadCancel()}
						acceptText="Aceptar"
						toggle={() => setShowPINModalCancel((state) => !state)}
						size="419px"
					>
						<div className="form-group">
							<label>PIN de seguridad</label>
							<input
								type="password"
								className="form-control"
								id="PIN"
								name="pin_seguridad"
								value={pinSeguridadCancel}
								onChange={(e) =>
									setPinSeguridadCancel(e.target.value)
								}
							/>
							<p
								className="font-weight-bold"
								style={{
									color: "gray",
									fontStyle: "italic",
									lineHeight: "13px",
									fontSize: "0.7rem",
								}}
							>
								Digite el pin de la sucursal para continuar con la cancelación de esta factura.
							</p>
						</div>
					</Modal>
					{/* ---AGREGAR PAGO MODAL--- */}
					<Modal
						title="Agregar Pago"
						show={showAgregarPagoModal}
						callback={() => {
							// if (!pagoInfo.pago || pagoInfo.pago <= 0) {
							// 	toast("Agregue el monto a pagar", "error");
							// 	return;
							// }
							setShowAgregarPagoModal(false);
							guardarYSalir("pagar");
						}}
						acceptText="Aceptar"
						toggle={() => {
							setPagoInfo({ pago: 0, tipo_pago: "", usarRetencion: false });
							setShowAgregarPagoModal(false);
						}}
						size="419px"
						footer={
							<PagoModalFooter
								setMostrar={mostrarPago}
								setTipoImpresionAfterPago={
									setTipoImpresionAfterPago
								}
								guardarYSalir={guardarYSalir}
								saving={saving}
							/>
						}
					>
						<PagoForm
                            pagoInfo={pagoInfo}
                            setPagoInfo={setPagoInfo}
                            isEdit={isEdit}
                            setPorPagar={setPorPagar}
                            form={form}
                            sumatoriaFinal={sumatoriaFinal}
                            condicionPago={condicionPago}
                        />
					</Modal>
					<input
						type="hidden"
						min="0"
						className="form-control"
						name="pago"
						value={
							pagoInfo.pago > sumatoriaFinal.total
								? sumatoriaFinal.total || 0
								: pagoInfo.pago || 0
						}
						onChange={() => {}}
					/>
				</div>
				<input
					type="hidden"
					min="0"
					className="form-control"
					name="tipo_pago"
					value={pagoInfo.tipo_pago || 'efectivo'}
					onChange={() => {}}
				/>
				<input
					type="hidden"
					name="metodo_pago[terminal_tarjeta]"
					value={pagoInfo.terminal_tarjeta}
				/>
				<input
					type="hidden"
					name="metodo_pago[tipo]"
					value={pagoInfo.tipo}
				/>
				<input
					type="hidden"
					name="metodo_pago[banco]"
					value={pagoInfo.banco}
				/>
				<input
					type="hidden"
					name="metodo_pago[num_aprobacion]"
					value={pagoInfo.num_aprobacion}
				/>
				<input
					type="hidden"
					name="metodo_pago[num_cheque]"
					value={pagoInfo.num_cheque}
				/>
				<input
					type="hidden"
					name="metodo_pago[num_transferencia]"
					value={pagoInfo.num_transferencia}
				/>
				<input
					type="hidden"
					name="metodo_pago[num_deposito]"
					value={pagoInfo.num_deposito}
				/>
				<input
					type="hidden"
					name="metodo_pago[num_transaccion]"
					value={pagoInfo.num_transaccion}
				/>
			</form>
			{/* ---CREAR CONTACTO MODAL--- */}
			<Modal
				show={showCreateContactoModal}
				blank={true}
				toggle={toggleCreateContactoModal}
				size="lg"
			>
				<Create toggle={toggleCreateContactoModal} fromFacturacion />
			</Modal>
			{/* ---EDITAR CONTACTO MODAL--- */}
			<Modal
				show={showEditContactoModal}
				blank={true}
				toggle={toggleEditContactoModal}
				size="lg"
			>
				<Edit
					toggle={toggleEditContactoModal}
					contacto={contactoInfo}
					fromFacturacion
				/>
			</Modal>
			{/* ---CONFIRMACIÓN CANCELAR FACTURA--- */}
			<Modal
				title="Cancelar Factura"
				show={showCancel}
				callback={() => cancelFactura(facturaActual.id)}
				acceptText="Aceptar"
				toggle={toggleCancelModal}
			>
				¿Estás seguro de que deseas cancelar esta factura? (Esta acción
				no se puede deshacer).
                <br />
                <br />
                Seleccione el motivo de la cancelación:
                <Select
                    name="razon_estado"
                    menuPosition="fixed"
                    required
                    placeholder="Seleccionar..."
                    onChange={e => {
                        setRazonCancelacion(e.value);
                    }}
                    options={[
                        {label: "01 Deterioro de Factura Pre-Impresa", value: "01 Deterioro de Factura Pre-Impresa"},
                        {label: "02 Errores de Impresión (Factura Pre-Impresa)", value: "02 Errores de Impresión (Factura Pre-Impresa)"},
                        {label: "03 Impresión Defectuosa", value: "03 Impresión Defectuosa"},
                        {label: "04 Duplicidad de Factura", value: "04 Duplicidad de Factura"},
                        {label: "05 Corrección de la Información", value: "05 Corrección de la Información"},
                        {label: "06 Cambio de Productos", value: "06 Cambio de Productos"},
                        {label: "07 Devolución de Productos", value: "07 Devolución de Productos"},
                        {label: "08 Omisión de Productos", value: "08 Omisión de Productos"},
                    ]}
                />
			</Modal>
		</>
	);
};

export default Form;
